import { langData } from '../../../../src/lang';

export const tableData = <T,>(data: T[], sortColumn: string | undefined, sortType: string | undefined) => {
    if (sortColumn && sortType) {
        return [...data].sort((a: any, b: any) => {
            let x = a[sortColumn];
            let y = b[sortColumn];

            if (typeof x === 'string') {
                x = x.charCodeAt(0);
            }

            if (typeof y === 'string') {
                y = y.charCodeAt(0);
            }

            if (sortType === 'asc') {
                return x - y;
            }

            return y - x;
        });
    }

    return data;
};

export type AdminPage =
    | 'overview'
    | 'analytics'
    | 'users'
    | 'orders'
    | 'order-manage'
    | 'payments'
    | 'promo'
    | 'rewards'
    | 'changelog'
    | 'news'
    | 'extensions'
    | 'application'
    | 'llm';

export const ADMIN_PAGES: { key: AdminPage; label: langData }[] = [
    { key: 'overview', label: 'AdminNavOverview' },
    { key: 'analytics', label: 'AdminNavAnalytics' },
    { key: 'users', label: 'AdminNavUsers' },
    { key: 'orders', label: 'AdminNavOrders' },
    { key: 'order-manage', label: 'AdminNavOrderManage' },
    { key: 'payments', label: 'AdminNavPayments' },
    { key: 'promo', label: 'AdminNavPromo' },
    { key: 'rewards', label: 'AdminNavRewards' },
    { key: 'changelog', label: 'AdminNavChangelog' },
    { key: 'news', label: 'AdminNavNews' },
    { key: 'extensions', label: 'AdminNavExtensions' },
    { key: 'application', label: 'AdminNavApplication' },
    { key: 'llm', label: 'AdminNavLlm' },
];
